module.exports = __webpack_public_path__ + "img/nfmlogo.c652fa55.svg";